import { cn } from "@/lib/utils";
import { Building2, DollarSign } from "lucide-react";
import { BadgePill } from "./BadgePill";

const tierConfig = {
  platinum: { badge: 'primary', color: 'border-electric-ice-blue/30' },
  gold: { badge: 'warning', color: 'border-soft-amber/30' },
  silver: { badge: 'default', color: 'border-soft-silver/30' },
  bronze: { badge: 'muted', color: 'border-white/[0.12]' },
};

export const SponsorCard = ({ 
  name, 
  logo,
  tier = 'silver',
  dealAmount,
  contactName,
  contactEmail,
  status = 'active',
  onClick,
  className 
}) => {
  const config = tierConfig[tier] || tierConfig.silver;
  
  return (
    <div 
      className={cn(
        "bg-graphite rounded-xl border border-white/[0.06] p-5 transition-all duration-200",
        "hover:border-white/[0.12]",
        config.color,
        onClick && "cursor-pointer",
        className
      )}
      onClick={onClick}
      data-testid="sponsor-card"
    >
      <div className="flex items-start gap-4">
        {/* Logo */}
        <div className="w-14 h-14 rounded-lg bg-obsidian border border-white/[0.06] flex items-center justify-center flex-shrink-0 overflow-hidden">
          {logo ? (
            <img src={logo} alt={name} className="w-full h-full object-cover" />
          ) : (
            <Building2 className="w-6 h-6 text-muted-text" />
          )}
        </div>
        
        {/* Info */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <h3 className="text-lg font-medium text-cloud-white truncate">
              {name}
            </h3>
            <BadgePill variant={config.badge}>
              {tier.charAt(0).toUpperCase() + tier.slice(1)}
            </BadgePill>
          </div>
          
          {dealAmount && (
            <div className="flex items-center gap-1 text-cool-mint mb-2">
              <DollarSign className="w-4 h-4" />
              <span className="font-mono font-medium">{dealAmount}</span>
            </div>
          )}
          
          {contactName && (
            <p className="text-sm text-soft-silver">{contactName}</p>
          )}
          {contactEmail && (
            <p className="text-xs text-muted-text truncate">{contactEmail}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SponsorCard;
